import React from "react";
import { Modal, Row, Col, Form } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import { isGuid } from "../../../../utils/string";
import { loadStripe } from '@stripe/stripe-js';
import { authorizeCard, cardErrorMessage } from './card-authorization';

import ConditionalButton from "../../../../layout/conditional-button";
import Address from "../../../../layout/address";

import {
    CardElement,
    ElementsConsumer,
    Elements,
} from "@stripe/react-stripe-js";

const stripePromises = {};

const stripePromiseForKey = (key) => {
    const publishableKey = String(key || "").trim();
    if (!publishableKey) return null;
    if (!stripePromises[publishableKey]) stripePromises[publishableKey] = loadStripe(publishableKey);
    return stripePromises[publishableKey];
};


class ModalForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.propsToState(this.props);
    }

    propsToState = (e) => {
        const person = e.person || {};
        const profileAddress = person.Residence || person.address || person.Company?.Address || {};

        return {
            uuid: isGuid(e.uuid) ? e.uuid : uuidv4(),
            name: e.name || e.selected?.name || [person.firstName, person.lastName].filter(Boolean).join(" ") || "",
            email: e.email || e.selected?.email || person.email || "",
            address: e.address || e.selected?.address || profileAddress || {},
            selected: e.selected || {},
            agreementAccepted: false,
            error: null,
            saving: false
        }
    }

    /* 
    componentDidUpdate = (oldProps) => {
        if (!deepEqual(oldProps, this.props)) {
            this.setState({
                ...this.state,
                ...this.propsToState(this.props)
            })
        }
    }
    /**/

    onShowModal = (e) => {
        this.setState({
            ...this.state,
            ...this.propsToState(this.props)
        })
    }

    onHideModal = (e) => {
        this.onCancel(e);
    }
    
    onCancel = (e) => {
        this.props?.onCancel(e);
    }
    
    onOk = (e) => {
        this.handleSubmit(e);
        /*
        this.props?.onOk({
            ...this.state
        });*/
    }

    onChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.name]: e.target.value
        });
    }

    onAgreementChange = (e) => {
        this.setState({
            ...this.state,
            agreementAccepted: e.target.checked
        });
    }

    onChangeAddress = (e) => {
        this.setState({
            ...this.state,
            address: {
                ...this.state.address,
                ...e
            }
        })
    }

    handleSubmit = async (event) => {
        // Block native form submission.
        event.preventDefault();
        if (this.state.saving) return;

        const { stripe, elements } = this.props;

        if (!this.props.edit && !this.state.agreementAccepted) {
            this.setState({ error: "Agreement is required before adding a payment method." });
            return;
        }

        if (!stripe || !elements) {
            this.setState({ error: "Payment processor is not ready. Check the Stripe publishable key configuration." });
            return;
        }

        // Get a reference to a mounted CardElement. Elements knows how
        // to find your CardElement because there can only ever be one of
        // each type of element.
        const card = elements.getElement(CardElement);

        if (card == null) {
            return;
        }

        this.setState({ saving: true, error: null });

        try {

        const acceptedAt = new Date().toISOString();
        const agreement = {
            accepted: true,
            name: this.props.agreement?.name || "PAYMENT_METHOD_AGREEMENT",
            version: this.props.agreement?.updatedAt || this.props.agreement?.version || "",
            acceptedAt
        };

        const intentResult = await this.props.getIntent({
            agreementAccepted: true,
            agreement
        });

        if (!intentResult?.success || !intentResult?.secret) {
            this.setState({ saving: false, error: intentResult?.error?.message || "Unable to prepare payment method authorization." });
            return;
        }

        const billing_details = {
            name: this.state.name,
            email: this.state.email,
            address: {
                city: this.state.address?.city,
                line1: this.state.address?.line1,
                line2: this.state.address?.line2,
                postal_code: this.state.address?.zipCode,
                state: this.state.address?.state,
                country: this.state.address?.country
            }
        };

        const setupResult = await authorizeCard({ stripe, card, billingDetails: billing_details, secret: intentResult.secret });
        const paymentMethod = setupResult.paymentMethod;

        if (setupResult.error) {
            this.setState({ error: cardErrorMessage(setupResult.error) });
            return;
        }

        if (setupResult.setupIntent?.status !== 'succeeded' || !setupResult.setupIntent?.payment_method) {
            this.setState({ saving: false, error: "Payment method authorization was not completed." });
            return;
        }

        await this.props.onOk({
            ...this.state,
            card: { ...paymentMethod.card },
            processorId: paymentMethod.id,
            setupId: setupResult.setupIntent?.id,
            agreement,
            accountType: "card",
            style: paymentMethod.card?.brand
        })
        } catch (error) {
            this.setState({ error: cardErrorMessage(error) });
        } finally {
            this.setState({ saving: false });
        }
    };

    render() {
        return (
            <form id="payment-form" name="payment-form" onSubmit={this.handleSubmit}>
                <Modal size="lg" backdrop="static" keyboard={false} show={this.props.show} onHide={this.onHideModal} onShow={this.onShowModal}>
                    <Modal.Body>
                        <Row className="g-3 pb-3 mt-1">
                            {this.state.error ? (
                                <Col xs="12">
                                    <div className="alert alert-danger mb-0">{this.state.error}</div>
                                </Col>
                            ) : null}
                            <Col xs="12">
                                { !this.props.edit ? (
                                <CardElement
                                    options={{
                                        hidePostalCode: true,
                                        style: {
                                            base: {
                                                fontSize: '24px',
                                                color: '#424770',
                                                '::placeholder': {
                                                    color: '#aab7c4',
                                                },
                                            },
                                            invalid: {
                                                color: '#9e2146',
                                            },
                                        },
                                    }}
                                />
                                ) : (``)}
                            </Col>
                            <Col xs="12">
                                <div className="licensee-field">
                                    <Form.Label>ISSUED TO</Form.Label>
                                    <Form.Control type="text" id="name" name="name" maxLength={50} value={this.state.name || ""} onChange={this.onChange} />
                                </div>
                            </Col>
                            <Col xs="12">
                                <div className="licensee-field">
                                    <Form.Label>EMAIL</Form.Label>
                                    <Form.Control type="email" id="email" name="email" maxLength={150} value={this.state.email || ""} onChange={this.onChange} />
                                </div>
                            </Col>
                            <Col xs="12">
                                <Address hide={{ county: true, country: false }} {...this.state?.address} onChange={this.onChangeAddress} />
                            </Col>
                            {!this.props.edit ? (
                                <Col xs="12">
                                    <div className="border rounded p-3">
                                        <div style={{ maxHeight: "160px", overflowY: "auto", whiteSpace: "pre-wrap" }}>
                                            {this.props.agreement?.value || ""}
                                        </div>
                                        <Form.Check
                                            className="mt-3"
                                            type="checkbox"
                                            id="payment-method-agreement"
                                            checked={this.state.agreementAccepted}
                                            onChange={this.onAgreementChange}
                                            label={this.props.agreement?.caption || "I agree"}
                                        />
                                    </div>
                                </Col>
                            ) : null}
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <ConditionalButton enabledVariant="outline-primary" disabledVariant="outline-muted" display enabled onEnabledClick={this.onCancel} icon="error-hexagon">cancel</ConditionalButton>
                        <ConditionalButton type="submit" enabledVariant="outline-primary" disabledVariant="outline-muted" display enabled={Boolean(!this.state.saving && (this.props.edit || this.state.agreementAccepted))} onEnabledClick={this.onOk} icon="save">ok</ConditionalButton>
                    </Modal.Footer>
                </Modal>
            </form>
        );
    }
}

const InjectedModalForm = (props) => {
  return (
    <ElementsConsumer>
      {({elements, stripe}) => (
              <ModalForm elements={elements} stripe={stripe} {...props} />
      )}
    </ElementsConsumer>
  );
};

const WrapHead = (props) => {
    const stripePromise = stripePromiseForKey(props.publishableKey);
    return (
        <Elements stripe={stripePromise} key={props.publishableKey || "payment-method"}>
            <InjectedModalForm {...props} />
        </Elements>
    );
};

export default WrapHead;
